import { dispatchAction } from '@ardoq/rxbeach';
import { debounce } from 'lodash';
import { containerHeightChanged } from '../actions/navigatorActions';

export const getDebouncedHeightChangedDispatcher = (
  actionNamespace: string
) => {
  const dispatchContainerHeightChanged = () =>
    dispatchAction(containerHeightChanged(), actionNamespace);

  return debounce(dispatchContainerHeightChanged, 16);
};
